import { Controller } from "@hotwired/stimulus";
import debounce from "debounce";

// Connects to data-controller="ransack-form"
export default class extends Controller {
  static targets = ["refocus"];

  initialize() {
    this.submit = debounce(this.submit.bind(this), 500);
  }

  connect() {
    if (window.localStorage.getItem("refocus") === "true") {
      if (this.hasRefocusTarget) {
        const inputField = this.refocusTarget.querySelector("input");
        if (inputField) {
          inputField.focus();
          const valueLength = inputField.value.length;
          inputField.setSelectionRange(valueLength, valueLength);
        }
      }
      window.localStorage.removeItem("refocus");
    }
  }

  submit() {
    if (this.hasRefocusTarget) {
      window.localStorage.setItem("refocus", "true");
    }
    this.element.requestSubmit();
  }

  resetField(name) {
    const fields = Array.from(this.element.querySelectorAll("input")).filter(
      (field) => field.type !== "hidden" && field.name.includes(name),
    );

    fields.forEach((field) => {
      if (field.type === "checkbox") {
        field.checked = false;
      } else {
        field.value = "";
      }
    });
  }
}
